import { render, staticRenderFns } from "./UpgradeBox.vue?vue&type=template&id=752d5d7a&"
import script from "./UpgradeBox.vue?vue&type=script&lang=js&"
export * from "./UpgradeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports